import script from "./introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./introduction.vue?vue&type=script&setup=true&lang=js"

import "./introduction.vue?vue&type=style&index=0&id=6a33638a&scoped=true&lang=scss"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a33638a"]])

export default __exports__